export const MODULES = [
  { key: "reponses", label: "Réponses", paths: ["/reponses"] },
  { key: "projets", label: "Projets", paths: ["/projets"] },
  { key: "pipeline", label: "Pipeline", paths: ["/pipeline", "/cockpit"] },
  { key: "marketing", label: "Marketing", paths: ["/demandes", "/avis-google", "/devis/validation", "/automatisations", "/automatisation-etapes", "/parcours", "/envois"] },
  { key: "prospection", label: "Fichiers de prospection", paths: ["/preparer-fichier", "/recyclage", "/recyclage-leads"] },
  { key: "statistiques", label: "Statistiques", paths: ["/statistiques", "/statistiques-agents"] },
];

const ADMIN_PATHS = ["/utilisateurs", "/parametres", "/devis", "/gmail", "/activite", "/transfert-nocrm"];

const moduleFor = (path) => MODULES.find((m) => m.paths.some((p) => path === p || path.startsWith(`${p}/`)));

export function canSee(user, path) {
  if (user.role === "admin") return true;
  const mod = moduleFor(path);
  if (mod) return user.modules.includes(mod.key);
  if (ADMIN_PATHS.some((p) => path === p || path.startsWith(`${p}/`))) return false;
  return user.role !== "guest";
}

export function homeFor(user) {
  if (user.role !== "guest") return "/accueil";
  const first = MODULES.find((m) => user.modules.includes(m.key));
  return first ? first.paths[0] : "/projets";
}
